linked_in_slide();

function linked_in_slide() {
    'use strict';
    var feed = document.querySelector('.team-members');
    if (!feed) return;

    tns({
        container: feed,
        responsive: {
            0: {
                items: 1,
                slideBy: 1,
            },
            768: {
                items: 2,
                slideBy: 2,
            },
            1000: {
                items: 4,
                slideBy: 4,
            }
        },
        items: 4,
        slideBy: 4,
        controls: false,
        loop: false,
        nav: true,
        navPosition: "bottom",

    });
}

function getInstagramBasicFeed() {
    const instagramFeeds = [];
    $.ajax({
        url: 'https://feeds.behold.so/VtWJqz05nIPA4Q7jgvG1',
        method: 'GET',
        dataType: 'json',
        success: function(response) {
            constructInstagramFeed(response);
        },
        error: function() {
            $.ajax({
                url: 'https://retro-rabbit.ghost.io/ghost/api/content/posts/?key=ce38a5ca4e48f57024b6ac506b',
                method: 'GET',
                data: {
                filter: 'tags:hash-noindex+tags:hash-instagram',
                limit: 3
                },
                dataType: 'json',
                success: function(response) {
                    if (response && response.posts && response.posts.length > 0) {
                    var posts = response.posts;
                    var parsedPosts = [];
            
                    for (var i = 0; i < posts.length; i++) {
                        var post = posts[i];
            
                        if (post.html) {
                        var jsonString = post.html.match(/{[^}]*}/)[0];
                        var jsonContent = JSON.parse(jsonString);
            
                        var newItem = {
                            hashtags: [],
                            mediaUrl: post.feature_image,
                            mentions: [],
                            caption: jsonContent.caption,
                            mediaType: 'IMAGE',
                            id: post.id,
                            permalink: jsonContent.permalink,
                            prunedCaption: jsonContent.caption,
                            timestamp: jsonContent.timestamp,
                            colorPalette: {
                            mutedDark: jsonContent.colorPalette.mutedDark
                            }
                        };
            
                        parsedPosts.push(newItem);
                        }
                    }
            
                    constructInstagramFeed(parsedPosts);
                    } else {
                        $('.instagram-container').css('justify-content', 'center');
                        $('.instagram-slider').css('display', 'none');
                        $('.instagram-header').css('max-width', '67%');
                    }
                },
                error: function() {
                    $('.instagram-container').css('justify-content', 'center');
                    $('.instagram-slider').css('display', 'none');
                    $('.instagram-header').css('max-width', '67%');
                }
            });
        }
    }); 
}

function calculateTimeSincePost(timestamp) {
    const now = new Date();
    const postDate = new Date(timestamp);
    const timeDiff = Math.abs(now.getTime() - postDate.getTime());
    const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));

    if (hoursDiff < 24) {
        return hoursDiff + " hours";
    } else if (hoursDiff < 24 * 30) {
        const daysDiff = Math.floor(hoursDiff / 24);
        return daysDiff + (daysDiff > 1 ? " days" : " day");
    } else if (hoursDiff < 24 * 30 * 12) {
        const monthsDiff = Math.floor(hoursDiff / (24 * 30));
        return monthsDiff + (monthsDiff > 1 ? " months" : " month");
    } else {
        const yearsDiff = Math.floor(hoursDiff / (24 * 30 * 12));
        return yearsDiff + (yearsDiff > 1 ? " years" : " year");
    }
}

function goBackOrRedirect(event) {
    event.preventDefault(); // prevent the default link behavior

    if (history.length > 1) {
        // go back to the previous page
        history.back();
    } else {
        // redirect to the base URL of the site
        window.location.href = "/";
    }
};

function breakMobileNames() {
    $('.about-author-name-mobile').html(function(_, html) {
        return html.replace(' ', '<br>');
    });
};

function getFirstNameOnly() {
    $('.first-name-only').html(function(_, html) {
        var fullName = $(this).text();
        var firstName = fullName.replace(/^(.*?)\s.*$/, '$1');
        return firstName;
        });
};

function constructInstagramFeed(instagramFeeds) {
    const container = $('#instagramFeed');
    container.empty();
    const profilePhoto = "/assets/img/svg/instagram/profile_picture.svg";
    const username = "teamretrorabbit";

    const svgPath1 = "/assets/img/svg/instagram/heart.svg";
    const svgPath2 = "/assets/img/svg/instagram/comment.svg";
    const svgPath3 = "/assets/img/svg/instagram/share.svg";
    const svgPath4 = "/assets/img/svg/instagram/save.svg";


    instagramFeeds.forEach((item, index) => {
        const post = $('<div>').addClass('instagram-slider-item');
        post.addClass('item-' + (index+1));
        post.addClass('pos-' + (index))
        const header = $('<div>').addClass('instagram-post-header');

        const profileImageContainer = $('<a>').addClass('instagram-profile-image-container').attr('href',"https://www.instagram.com/teamretrorabbit").attr('aria-label',"Our instagram page").attr('target',"_blank");
        const profileImage = $('<img>').addClass('instagram-profile-image').attr('src', profilePhoto).attr('alt', "");
        const profileUsername = $('<div>').addClass('instagram-profile-username').text(username);
        
        var imageSrc;
        if (item.mediaType === "VIDEO") {
            imageSrc = item.thumbnailUrl;
        } 
        else if (item.mediaType === "CAROUSEL_ALBUM") {
            var childItem = item.children[0];

            if (childItem.mediaType === "VIDEO") {
                imageSrc = childItem.thumbnailUrl;
            } else {
                imageSrc = childItem.mediaUrl;
            }
        } 
        else { //all that is left is "IMAGE", which is also our fallback
            imageSrc = item.mediaUrl;
        }
        const postImage = $('<img>').addClass('instagram-post-image').attr('src', imageSrc).attr('alt', "").attr('style', 'background-color: rgb(' + item.colorPalette.mutedDark + ')').attr('loading', 'lazy');

        const content = $('<div>').addClass('instagram-post-content');
        const captionUsername = $('<div>').addClass('instagram-post-content-username').text(username);

        const prunedCaption = item.prunedCaption.substring(0, 90);
        const captionText = (prunedCaption.length < item.prunedCaption.length) ? prunedCaption + "..." : prunedCaption;
        const caption = $('<div>').addClass('instagram-post-content-caption').text(captionText);

        const timestamp = $('<div>').addClass('instagram-post-content-timestamp').text(calculateTimeSincePost(item.timestamp) + ' ago');
        const actionBar = $('<div>').addClass('instagram-action-bar');
        const actionBarLeft = $('<a>').addClass('instagram-action-bar-left').attr('href', item.permalink).attr('aria-label',"View this post on Instagram").attr('target',"_blank");
        const actionBarRight = $('<a>').addClass('instagram-action-bar-right').attr('href', item.permalink).attr('aria-label',"View this post on Instagram").attr('target',"_blank");
        const icon1 = $('<img>').addClass('instagram-action-bar-icon').attr('src', svgPath1).attr('alt', "");
        const icon2 = $('<img>').addClass('instagram-action-bar-icon').attr('src', svgPath2).attr('alt', "");
        const icon3 = $('<img>').addClass('instagram-action-bar-icon').attr('src', svgPath3).attr('alt', "");
        const icon4 = $('<img>').addClass('instagram-action-bar-icon').attr('src', svgPath4).attr('alt', "");

        profileImageContainer.append(profileImage);
        header.append(profileImageContainer, profileUsername);
        actionBarLeft.append(icon1, icon2, icon3);
        actionBarRight.append(icon4);
        actionBar.append(actionBarLeft, actionBarRight);

        content.append(actionBar, captionUsername, caption, timestamp);

        post.append(header, postImage, content);
        container.append(post);

    });
    getInstagramCarousel();
};
